import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { CUSTOM_FIELD_PREFIX_URL } from './constants/config.custom-field'

const ListPage = lazy(() => import('./pages/ListPage.CustomField'))

const CustomFieldRouters: AppRouterItem[] = [
  {
    path: `${CUSTOM_FIELD_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default CustomFieldRouters
